<!-- RAB作動履歴画像出力 ダイアログ -->
<b-modal v-model="modal_requirement_MVS2" size="lg" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <template v-if="phase !== 'history_list' && phase !== 'execution'">
          <div class="w-100">
            <div class="box-margin-right work-support-message" style="white-space: break-spaces;">{{ workSupportMessage }}</div>
          </div>
        </template>
        <template v-if="phase === 'start'">
          <div class="text-left align-middle mt-3">
            <div class="work-support-message">{{ $t(`${i18nWsKey}.label_start_confirm`) }}</div>
          </div>
          <div class="mt-3">
            <b-form-checkbox v-model="confirmChecked">
              <div class="work-support-message">{{ $t(`individual.label_confirm_yes`) }}</div>
            </b-form-checkbox>
          </div>
          <div class="text-left align-middle mt-3">
            <div class="work-support-message">{{ $t(`${i18nWsKey}.label_start_agreement`) }}</div>
          </div>
          <div class="mt-3">
            <b-form-checkbox v-model="agreementChecked">
              <div class="work-support-message">{{ $t(`individual.label_confirm_yes`) }}</div>
            </b-form-checkbox>
          </div>
        </template>
        <template v-if="phase === 'history_list'">
          <div style="max-height: 395px; overflow: auto;">
            <!-- 共通コンポーネントを使用すると、チェックボックスに変更を加えた際に、再描画されてソートが解除されてしまう -->
            <table class="table table-sm overflow-auto simple-table">
              <tr v-if="columns">
                <th v-for="(column, i) in columns" :key="i">
                  <div v-if="column.useSort" class="table-header-cursor" @click="sort(column)">
                    <span>{{ $t(column.label) }}</span>
                    <span v-if="currentSort == column.name" v-html="getSortIcon()"></span>
                  </div>
                  <div v-else>
                    <span>{{ $t(column.label) }}</span>
                  </div>
                </th>
              </tr>
              <tr v-for="(data, index) in sortedDisplayList" :key="index">
                <td v-for="(column, i) in columns" :key="i" :class="getTdStyle(index)" class="cursor-default">
                  <div v-if="column.name === 'selected'">
                    <input type="checkbox" v-model="data.selected"/>
                  </div>
                  <span v-else>{{ data[column.name] }}</span>
                </td>
              </tr>
            </table>
          </div>
        </template>
        <template v-if="phase === 'execution'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="text-left align-middle">
                <custom-Progress :value="progress" :max="progressMax"
                  :message="$t(`${i18nWsKey}.REQ_SP_WS_MVS2_TXT_3`) + `(${processedRecord}/${totalRecord})`" />
              </div>
            </div>
          </div>
        </template>
      </div>
    </b-overlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center">
      <!-- 次へボタン -->
      <b-button v-if="phase === 'start'" size="sm" variant="primary" @click="onNextClicked" class="mx-2 mt-2" :disabled="isDisableOk">
        {{ $t('message.button_agreement_confirm') }}
      </b-button>
      <!-- 戻るボタン -->
      <b-button v-if="phase === 'start'" size="sm" variant="outline-primary" @click="closeWizard" class="mx-2 mt-2" :disabled="isLoading">
        {{ $t('message.common_button_back') }}
      </b-button>
      <!-- 保存ボタン -->
      <b-button v-if="phase === 'history_list'" size="sm" variant="primary" @click="onSaveClicked" class="mx-2 mt-2" :disabled="isDisableOk">
        {{ $t('message.common_button_save') }}
      </b-button>
      <!-- 全選択ボタン -->
      <b-button v-if="phase === 'history_list'" size="sm" variant="primary" @click="onAllSelectClicked" class="mx-2 mt-2" :disabled="isLoading">
        {{ $t('individual.common_button_select_all') }}
      </b-button>
      <!-- 終了ボタン -->
      <b-button v-if="phase === 'history_list'" size="sm" variant="outline-primary" @click="onFinishClicked" class="mx-2 mt-2" :disabled="isLoading">
        {{ $t('individual.label_button_finish') }}
      </b-button>
      <!-- OKボタン -->
      <b-button v-if="showButtonOk" size="sm" variant="primary" @click="onOkClicked" class="mx-2 mt-2" :disabled="isLoading">
        {{ $t('message.common_button_ok') }}
      </b-button>
    </div>
  </template>
</b-modal>